var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWazirx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1024px",
    height: "1024px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "#3067f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.7 258.91a28.05 28.05 0 0 1 1.82-2.91q56.07 83.79 112.32 167.47Q493.92 520.9 367 618.32c-23.25-.06-46.5 0-69.76 0q38.7-66.78 77.56-133.48C395.52 449.18 416.13 413.5 437 378zM277.2 590.23Q324 510 370.72 429.62l.54-1.25Q313.55 387.79 256 347q10.65 121.62 21.2 243.23zm467.6 29.93Q756.42 486.74 768 353.3 594.29 486.69 420.66 620.17zm-468.2 86.06h467.76v-56.08H276.63q-.04 28.04-.04 56.09z",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWazirx);
export default __webpack_public_path__ + "static/media/Wazirx.c84607fe63e4bb3a77dad2e703e36090.svg";
export { ForwardRef as ReactComponent };